<template>
  <div>
    <img v-show="isShowCyw" class="head-img" src="../img/company.png" alt />
    <!-- <div v-show="!isShowCyw" style="margin-top: 6rem"></div> -->
    <div :style="{ paddingTop: isShowCyw ? '0' : '6rem' }">
      <van-field v-show="!isShowMFACode" v-model="userName" clearable label="账号" placeholder="请输入账号（用户代码）" />
      <van-field v-show="!isShowMFACode && !isPhoneLogin" v-model="passWord" type="password" label="密码"
        placeholder="请输入密码" />
      <van-field v-model="userPhone" v-show="!isShowMFACode && isPhoneLogin" center clearable label="手机号"
        placeholder="请输入账号手机号码">
        <template #button>
          <van-button size="small" type="primary" @click="sendVCode" :disabled="sendVCodeBtnDisabled"><span
              v-show="!isShowSendVCodeLoadingTime">发送验证码</span><van-count-down v-show="isShowSendVCodeLoadingTime"
              ref="countDown" :time="sendVCodeLoadingTime" :auto-start="false" format="ss秒"
              @finish="sendVCodeLoadingTimeFinish" /></van-button>
        </template>
      </van-field>
      <van-field v-show="!isShowMFACode && isPhoneLogin" v-model="vCode" label="验证码" placeholder="请输入短信验证码" />
      <van-field v-show="isShowMFACode" v-model="mfaCode" type="number" maxlength="6" left-icon="lock"
        placeholder="请输入虚拟MFA验证密码" />
      <div v-show="isShowCyw" style="display: -webkit-inline-box; margin-top: 0.4rem;">
        <van-checkbox v-model="agreement" icon-size="18">我已阅读并同意</van-checkbox>
        <a style="
            text-decoration: underline;
            color: blue;
            line-height: 0.625rem;
          " @click="showUserAgreement">《用户协议》</a>
      </div>
      <div id="captcha" style="
          margin-top: 20px;
          margin-left: auto;
          margin-right: auto;
          width: calc(90% + 30px);
        "></div>
         <!-- @click="onLogin" -->
      <van-button size="large" id="login" :loading="loading" :disabled="disabled" loading-text="登录中..."
        style="
          background-color: #555562;
          width: 90%;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          border: none;
          color: #fff;
          margin-top: 50px;
        ">登录</van-button>
      <van-button size="large" @click="
        isPhoneLogin = true;
      passWord = '';
      " v-show="!isPhoneLogin && !isShowMFACode" style="
          background-color: #555562;
          width: 90%;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          border: none;
          color: #fff;
          margin-top: 20px;
        ">手机验证码登录</van-button>
      <van-button size="large" @click="
        isPhoneLogin = false;
      vCode = '';
      " v-show="isPhoneLogin && !isShowMFACode" style="
          background-color: #555562;
          width: 90%;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          border: none;
          color: #fff;
          margin-top: 20px;
        ">返回密码登录</van-button>
      <van-button size="large" @click="doReload" style="
          background-color: #555562;
          width: 90%;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          border: none;
          color: #fff;
          margin-top: 20px;
        ">刷新</van-button>
    </div>
    <van-dialog id="changPwdWin" v-model="ForcePasswordChange" :title="changePwdTitle" show-confirm-button
      :show-cancel-button="isAllowClosePwdWin" :before-close="changPwd" @close="disabled = isAllowClosePwdWin">
      <!-- 用户代码 -->
      <van-field v-model="sysUser.UserCode" label="用户代码" label-width="56" readonly disabled label-align="left" />
      <!-- 用户名称 -->
      <van-field v-model="sysUser.UserName" label="用户名称" label-width="56" readonly disabled label-align="left" />
      <!-- 原密码 -->
      <van-field v-model="oldpwd" type="password" label-width="56" label="原密码 " label-align="left"
        placeholder="请输入原密码" />
      <van-field v-model="newpwd1" label-width="56" label="新密码 " label-align="left" placeholder="请输入新密码">
        <template #button>
          <van-button size="small" type="primary" @click="generateRandomPassword">生成并复制密码</van-button>
        </template></van-field>
      <van-field v-model="newpwd2" label="确认密码" label-width="56" label-align="left" placeholder="再次输入新密码" />
    </van-dialog>

    <!-- 用户协议 -->
    <van-dialog v-model="showAgreement" title="“车盈网”互联网包车用户协议" show-cancel-button confirm-button-text="我同意"
      @confirm="agreement = true">
      <div style="
          max-height: 11rem;
          overflow: scroll;
          text-align: left;
          padding: 0.3rem;
        ">
        <h6>1.特别提示</h6>
        <p>
          1.1本《互联网包车用户协议》（以下简称“本协议”）是您（以下简称“您”、“乘客”或“用户”）与广州市悦到信息科技有限公司（以下简称“本公司”或“我们”）之间关于您在车盈网平台中注册并使用和互联网包车信息平台业务（包括但不限于通过网页、微信公众号或移动智能终端）以及通过平台获得的相关信息、建议或服务等相关事宜所订立的协议。
        </p>
        <p>
          1.2车盈网互联网包车信息平台是广州市悦到信息科技有限公司拥有合法权益的，为使用互联网包车业务的乘客和道路旅客运输企业提供相关技术服务的信息网络平台。
        </p>
        <p>
          1.3请您认真阅读本协议，并充分理解本协议各条款的内容。您在使用平台提供的服务之前，必须同意并接受本协议
        </p>
        <p>
          1.4您明确同意，车盈网互联网包车信息平台有权根据法律法规的变化及运营的需要，不时对前述协议和条款进行修改和公布，您应主动不时查阅信息平台的公示，若不同意修改的内容，您可以停止使用平台业务。若继续使用平台服务，则视为接受我公司对前述协议和条款的修改。
        </p>
        <h6>2.服务内容</h6>
        <p>
          2.1互联网包车服务是指乘客通过互联网在平台上发布自己的出行路线需求，信息平台经过收集用户出行线路需求并发布线路信息供其他乘客选择合乘，同时信息平台将合乘乘客的出行线路信息通知合适及相匹配的道路旅客运输企业，由运输企业完成乘客运输服务的信息化及技术服务。
        </p>
        <p>
          2.2车盈网平台提供的不是乘客的运输服务，而是方便乘客发布定制线路信息并促成其他乘客选择合乘线路达成合乘出行需求并共同分担运输费用的信息化技术服务，平台帮助合乘的乘客匹配合适的运输公司，由运输公司实际承担运输主体责任。
        </p>
        <h6>3.服务使用</h6>
        <p>
          3.1乘客应保证向车盈网平台提供的信息真实、准确、完整，车盈网平台在任何时候都有权验证乘客提供的信息，由于乘客发布虚假的信息所导致的任何责任和损失，应由乘客负责。
        </p>
        <p>
          3.2根据国家反恐怖法的要求，乘客在发布定制线路信息或预订合乘线路时，需要提供有效的身份证明信息，在乘坐车辆时，需出示真实、有效的身份证明，做到人、证、票合一。
        </p>
        <p>3.3乘客需按照合乘要求约定的时间和地点等候乘车</p>
        <p>
          3.4旅客不得携带危险品及其他法律法规规定禁止携带的物品搭乘合乘的车辆，成人票旅客行李的重量不能超过10公斤，儿童票旅客行李的重量不能超过5公斤。带上车的行李体积每件不超过20×30×40厘米，超出此体积行李需放行李舱。在上车时需接受人身、行李安全检查，否则运输企业有权拒绝乘客乘车。
        </p>
        <p>
          3.5合乘的乘客在乘坐车辆前，为防止运输企业更换车辆，请仔细核对车辆信息是否与平台信息显示的车辆一致，如发现车辆与平台显示的信息不一致，应拒绝乘坐，并可向平台客服投诉，平台核实后可以向承担运输服务的运输企业追责。
        </p>
        <p>
          3.6乘客有权要求运输公司提供良好的乘车环境，确保车辆设施齐全有效，车辆车厢清洁、卫生。乘客在运输过程中可向车盈网投诉运输企业的不良行为，车盈网平台需协助乘客协商运输企业解决投诉问题。
        </p>
        <p>
          3.7乘车过程中，乘客需自行保管随身携带的物品，车盈网平台及运输企业不承担任何的保管义务，若有遗失，车盈网平台和运输企业不承担赔偿责任。
        </p>
        <p>
          3.8乘客不得在车辆运输过程中进行违反平台规则的不文明行为（包括吸烟、喝酒、吐痰，以及其他违反平台规则的行为），不得进行或要求车辆驾驶员进行违反相关交通规则或其他法律法规的行为，因您违反禁止行为的原因导致有关部门行政处罚、人员受伤、发生交通事故、造成车辆损坏或其他损失的，您应向受损方进行赔偿。
        </p>
        <h6>4.价格及付款</h6>
        <p>
          4.1乘客通过车盈网平台支付的费用中包含代收分摊的运输公司车费和车盈网提供信息技术服务的平台服务费，这些价格可能会根据市场供需情况随时更新。
        </p>
        <p>
          4.2乘客在车盈网平台使用乘客自己的第三方支付账户（包括但不限于微信支付或支付宝支付）进行支付，我们不接受线下的现金交易支付。我们对于电子支付服务商或银行发生的错误不承担责任。
        </p>
        <p>
          4.3在乘客提出发票要求时，车盈网平台将为乘客开具发票，具体发票开具及申请规则，请参见应用程序上的开票说明。
        </p>
        <h6>5.平台责任</h6>
        <p>
          5.1在车盈网平台上向乘客提供的信息及推荐的服务仅供您参考。我们将在合理的范围内尽力保证信息的准确，但无法保证其中没有任何错误、缺陷、恶意软件和病毒。对于使用（或无法使用）车盈网平台所提供的信息而导致的任何伤害，我们不承担责任。
        </p>
        <p>
          5.2车盈网平台提供的互联网包车服务，是我们根据乘客发出的定制线路需求，经过后台大数据信息处理后在平台上公布可合乘的线路信息，其他乘客可以进行选择合乘；在发布的合乘线路成行后，平台帮助合乘乘客选择合适的运输公司提供线下的运输服务。因此，从乘客在平台上发送定制线路需求开始，经过定制线路发布、乘客选择合乘并预订座位，平台帮助合乘的乘客向运输企业包车，并将包车信息告知合乘乘客，通知乘客上车时间地点为止，此过程为平台信息服务区间，由车盈网平台承担信息服务责任。从乘客肢体接触到车辆及上车开始，到线下运输服务结束乘客离开车辆为止，为运输企业的承运区间，由运输企业承担运输责任。
        </p>
        <p>
          5.3为提升服务品质，保障乘客的安全，平台将根据现行的法律法规为合乘乘客选择符合运输资质要求的合法运输企业，并代表合乘乘客团体与运输企业签订包车服务合同，要求并监督运输企业调派有运营资质的合法车辆和司机承担运输任务，并按约定的线路、时间、地点完成运输服务，并在运输服务过程中保障乘客的安全。平台将通过信息化技术手段规范并监督运输企业的运输服务。
        </p>
        <p>
          5.4车盈网平台为扩大促成合乘的效果或范围，可以将合乘出行的需求共享发布至其他合作的第三方网络服务平台供乘客选择合乘线路，并按照本平台制定的规则完成信息撮合合乘服务，其他第三方网络平台在发布合乘线路时会标记有“数据来自车盈网”以提示用户选择，车盈网平台将监督合作平台以不低于车盈网平台信息和用户信息保护制度的标准要求获取和使用共享数据。
        </p>
        <h6>6.知识产权声明</h6>
        <p>
          6.1车盈网互联网包车信息平台的一切知识产权，以及相关的所有信息内容均受国家著作权法、商标法、专利法和相应的国际条款及其他知识产权法律法规的保护。
        </p>
        <p>
          6.2未经本公司书面同意，用户不得为任何营利性或非营利性的目的自行实施、利用、转让或许可任何第三方实施、利用转让上述知识产权，本公司保留追究上述未经许可行为的权利。
        </p>
        <h6>7.服务的变更、中断、或终止</h6>
        <p>
          7.1用户理解，本公司需要定期或不定期地对网络服务平台或相关设备进行检修或者维护，且互联网连接能力受到全球网络稳定性、技术状态、政府管制、计算机病毒、黑客攻击等既存不确定性的限制，如因此类情况造成的服务中断，本公司无需为此承担任何责任。
        </p>
        <p>
          7.2如发生下列任何一种情形，本公司有权随时中断或终止向您提供本协议下的服务而无需对您或任何第三方承担任何责任：
        </p>
        <p>您提供的信息资料不真实</p>
        <p>你违反本协议中的使用规则</p>
        <p>您未按要求向本公司支付相应的服务费</p>
        <p>您的行为违反法律法规或者政府的规定。</p>
        <p>
          7.3用户在使用平台提供的行为不得从事违反法律法规或国家的政策要求，或侵犯任何第三方合法权益的情况，如存在上述情况，用户应自行承担相应的法律责任，同时本公司有权禁止用户继续使用本平台，如有此给本公司造成损失的，用户应承担赔偿责任。
        </p>
        <h6>8.隐私保护</h6>
        <p>
          8.1本公司保证不对外或向非本公司关联企业的第三方提供用户的注册数据及用户的使用记录，但下列情况除外：
        </p>
        <p>事先获得用户的明确授权</p>
        <p>根据有关的法律法规要求</p>
        <p>安装相关政府主管部门的要求</p>
        <p>为维护社会公众的利益</p>
        <p>为维护本公司的合法权益</p>
        <p>
          8.2在不透露单个用户隐私数据的前提下，本公司有权对整个用户数据进行分析并在合法范围内对用户数据进行商业上的利用。
        </p>
        <h6>9.免责声明</h6>
        <p>
          9.1用户明确同意其使用本公司网络服务所存在的风险将完全由其自己承担；因其使用本公司网路服务而产生的一起后果也由其自己承担，本公司对用户不承担任何责任。
        </p>
        <p>
          9.2用户同意，车盈网定制包车信息平台所提供的功能受制于我国交通法律法规和管理条例，即本产品的功能和条例发生冲突时，应以各地的交通法律法规和管理条例为最高准则。任何通过车盈网平台服务直接或间接违反当地交通法律法规和管理条例的行为，该后果应由用户承担。如有举证需要，本公司可以向有关管理部门提供相关资料作为证据。
        </p>
        <p>
          9.3用户理解安全驾驶的重要性，且保证在任何可能引起安全隐患的情况下均不得使用车盈网信息平台，并同意一切因使用车盈网平台服务而导致的安全隐患和因此产生的纠纷和交通事故，均由承担运输责任的运输企业负责，本公司概不负责承担。如有举证需要，本公司可以向有关部门提供相关资料作为证据。
        </p>
        <p>
          9.4用户理解车盈网信息平台提供的服务，但无需对用户使用服务相关行为所造成的损失负担任何责任，例如乘客于乘车时丢失物品、车辆因交通堵塞或司机对于运载时间估算错误所造成的损失。用户应自行解决上述事项所发生的争议。
        </p>
        <p>
          9.5我们对于电子支付服务商或银行发生的错误不承担责任，我们将获取与您使用服务相关的特定交易明细记录，在使用这些信息时我们将严格遵守相关的法律法规和公司的各项政策。
        </p>
        <h6>10.争议解决</h6>
        <p>
          10.1本用户协议适用于中国法律。关于本协议的违约、终止、履行、解释或有效性，或者车盈网信息平台使用所产生的或与其相关的任何冲突、赔偿或纠纷（统称为“争议”），均应由车盈网信息平台营运方住所地有管辖权的法院予以审理。
        </p>
      </div>
    </van-dialog>
  </div>
</template>
<script>
// import aliCode from "../js/aliCode.js";

export default {
  watch: {
    mfaCode() {
      if (this.isShowMFACode) {
        if (this.mfaCode.length == 6) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      }
    },
  },
  data() {
    return {
      agreement: true,
      showAgreement: false,
      userName: "",
      passWord: "",
      loading: false,
      disabled: false,
      isReload: null,
      ForcePasswordChange: false,
      changePwdTitle:
        "经检测您的账号密码安全系数较低，请您先进行更改密码再进行后续操作",
      sysUser: {
        GID: null,
        UserCode: "",
        UserName: "",
        CompGID: null,
      },
      oldpwd: null,
      newpwd1: null,
      newpwd2: null,
      mfaCode: null,
      isShowMFACode: false,
      isShowCyw: true,
      isAllowClosePwdWin: false,
      isPhoneLogin: false, //手机验证码登录
      userPhone: "",
      vCode: "",
      isShowSendVCodeLoadingTime: false,
      sendVCodeLoadingTime: 120000,
      sendVCodeBtnDisabled: false,
    };
  },
  methods: {
    //短信验证码倒计时结束
    sendVCodeLoadingTimeFinish() {
      //重置
      this.sendVCodeBtnDisabled = false;
      this.isShowSendVCodeLoadingTime = false;
      this.$refs.countDown.reset();
    },
    //发送短信验证码
    sendVCode() {
      let that = this;
      if (!that.userName) {
        that.$dialog.alert({
          title: "提示",
          message: "账号不能为空",
        });
        return;
      }
      if (!that.userPhone) {
        that.$dialog.alert({
          title: "提示",
          message: "手机号码不能为空",
        });
        return;
      }
      let params = {
        UserPhone: that.userPhone,
        UserCode: that.userName,
      };
      this.sendVCodeBtnDisabled = true;
      that.$http
        .post(that.$api.sendLoginCode, that.$qs.stringify(params))
        .then((res) => {
          if (!res.success) {
            that.sendVCodeBtnDisabled = false;
          }
          if (res.success) {
            that.$toast.success("短信验证码发送成功");
            that.isShowSendVCodeLoadingTime = true;
            that.$refs.countDown.start();
          }
        });
    },
    //生成随机密码并复制
    generateRandomPassword() {
      this.newpwd1 = this.$utils.randomPassword(10);
      this.$copyText(this.newpwd1).then(
        (e) => {
          alert("密码生成成功：" + this.newpwd1 + "已复制到剪贴板");
          //console.log("复制成功：", e);
        },
        (e) => {
          alert("密码生成成功，但是复制失败，请手动复制。");
          //console.log("复制失败：", e);
        }
      );
    },
    showUserAgreement() {
      this.showAgreement = true;
    },
    changPwd(action, done) {
      console.log(action);
      if (action == "cancel") {
        done();
        this.$router.push({ name: "Home", params: {} });
        return;
      }
      if (!this.oldpwd) {
        this.$dialog.alert({
          message: "请输入原密码",
          getContainer: "#changPwdWin",
        });
        done(false);
        return;
      }
      if (!this.newpwd1 || this.newpwd1 !== this.newpwd2) {
        this.$dialog.alert({
          message: "两次密码输入不匹配，请重新输入",
          getContainer: "#changPwdWin",
        });
        done(false);
        return;
      }
      if (this.oldpwd === this.newpwd1) {
        this.$dialog.alert({
          message: "您输入的新密码和原密码一致，请重新设置一个密码！",
          getContainer: "#changPwdWin",
        });
        done(false);
        return;
      }
      let reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[_~`!@#$%^&*()\-+={}\[\]\|\\:;"'<>,\.\?\/])[\w~`!@#$%^&*()\-+={}\[\]\|\\:;"'<>,\.\?\/]{10,20}$/;
      if (!reg.test(this.newpwd1)) {
        this.$dialog.alert({
          message:
            "请输入由10位到20位、由数字、大写、小写字母和特殊字符四种符号组成的密码！",
          getContainer: "#changPwdWin",
        });
        done(false);
        return;
      }
      this.loading = true;
      //const sm2 = require("sm-crypto").sm2;
      var oldpwdEnc = "";
      var newpwdEnc = "";
      try {
        oldpwdEnc = sm2.doEncrypt(this.oldpwd, window._UserSm2PublicKey, 1);
        newpwdEnc = sm2.doEncrypt(this.newpwd1, window._UserSm2PublicKey, 1);
      } catch (error) {
        //不支持sm2 直接传明文
        oldpwdEnc = this.oldpwdEnc;
        newpwdEnc = this.newpwd1;
      }

      var params = {
        _CompGID: this.sysUser.CompGID,
        _OperGID: this.sysUser.GID,
        UserGID: this.sysUser.GID,
        OldPwd: oldpwdEnc,
        NewPwd: newpwdEnc,
      };
      this.$http
        .post(this.$api.onChangePwd, this.$qs.stringify(params))
        .then((res) => {
          this.loading = false;
          if (res.success) {
            this.$toast("修改密码成功");
            done();
            let user_name = window.localStorage.getItem("username");
            //修改成功 刷新当前登录页 清空缓存账号密码
            window.localStorage.clear();
            //修改成功，记录新密码至缓存
            window.localStorage.setItem("username", user_name);
            window.localStorage.setItem("userpwd", this.newpwd1);
            this.doReload();
          } else {
            done(false);
          }
        });
    },
    doReload() {
      this.$toast.loading({
        mask: false,
        forbidClick: true,
        message: "加载中...",
        duration: 0,
      });
      window.location.reload();
      //this.$router.go(0);
    },
    //登录
    onLogin(nvcVal) {
      let that = this;
      if (!this.userName) {
        this.$dialog.alert({
          title: "提示",
          message: "账号不能为空",
        });
        return;
      }
      if (!this.passWord && !this.vCode) {
        this.$dialog.alert({
          title: "提示",
          message: "密码或验证码不能为空",
        });
        return;
      }
      if (!this.agreement) {
        this.$dialog.alert({
          title: "提示",
          message: "请阅读并同意《用户协议》再进行操作",
        });
        return;
      }
      //if (
      //  (!nvcVal || typeof nvcVal != "string") &&
      //  typeof getNVCVal != "function"
      //) 
      if(!nvcVal){
        this.$dialog
          .alert({
            title: "提示",
            message: "数据尚未加载完成,请稍后再试",
          })
          .then(() => {
            that.doReload();
          });

        return;
      }
      debugger
      this.loading = true;
      this.disabled = true;
      let params = {};
      params.UserCode = this.userName;
      // const sm2 = require("sm-crypto").sm2;
      if (this.passWord) {
        try {
          params.UserPwd = sm2.doEncrypt(
            this.passWord,
            window._UserSm2PublicKey,
            1
          );
        } catch (error) {
          //不支持sm2 直接传明文
          params.UserPwd = this.passWord;
        }
      }

      //params.UserPwd = this.$md5(this.passWord);
      params.UserTwpwd = this.mfaCode;
      params.isMD5 = 0;
      params.VerificationCode = this.vCode;
      // eslint-disable-next-line
      // nvcVal = nvcVal && typeof nvcVal == "string" ? nvcVal : getNVCVal();
      params.NVCVal = nvcVal;
      //window.localStorage.setItem("_cyw_token", "");
      this.$http
        .post(this.$api.login, this.$qs.stringify(params))
        .then((res) => {
          console.log("登录");
          console.log(res);
          that.loading = false;
          if (!res.success) {
            that.disabled = false;
            // eslint-disable-next-line
            // nvcReset();
          }
          if (res.success) {
            if (res.code == "10001") {
              this.isShowMFACode = true;
            }

            if (res.code == "100" || res.code == "200") {
              //登录成功 清除缓存
              window.localStorage.clear();

              //如果带了不显示车盈网相关信息参数,则需将参数传递,用于页面判断
              if (this.$route.query && this.$route.query.isShowCyw == "false") {
                window.localStorage.setItem("isShowCyw", "false");
                this.isShowCyw = false;
              } else {
                window.localStorage.setItem("isShowCyw", "true");
                this.isShowCyw = true;
              }

              window.localStorage.setItem(
                "isShowCyw",
                this.isShowCyw ? "true" : "false"
              );
              window.localStorage.setItem(
                "expireTime",
                new Date().getTime() + 1200000
              );
              window.localStorage.setItem("_cyw_token", res.data.token);
              //判断参数 IsRememberPwd 如果为 0 不记住账号密码
              if (that.$utils.getSysParams("IsRememberPwd") !== "0") {
                // 1.记住密码--登录成功后将密码保存到localStorage中
                window.localStorage.setItem("username", this.userName);
                window.localStorage.setItem("userpwd", this.passWord);
              }
              that.getUserInfo();
              // alert('登录成功')
            }
            // aliCode.codeRespone(res.code);
          }
        });
    },
    getUserInfo: function () {
      let that = this;
      this.loading = true;
      let params = {
        _Authorization: window.localStorage.getItem("_cyw_token"),
      };
      this.$http
        .post(this.$api.getUserInfo, this.$qs.stringify(params))
        .then((res) => {
          that.disabled = false;
          // console.log("登录");
          // console.log(res);
          that.loading = false;
          if (res.success) {
            // console.log("res.data.SysRights", res.data.SysRights);
            this.sysUser = res.data.SysUser;

            //res.data.SysUserDefPwd = params.LoginPwd //保存密码
            //window.localStorage.setItem('userpwd', params.LoginPwd)
            //alert(params.LoginPwd)
            let CompInfo = {
              CompGID: res.data.SysUser.CompGID,
              CompName: res.data.SysUser.CompName,
            };
            this.$store.commit("newCompInfo", CompInfo);
            window.localStorage.setItem(
              "adminInfo",
              JSON.stringify(res.data.SysUser)
            );
            window.localStorage.setItem(
              "adminParams",
              JSON.stringify(res.data.SysParams)
            );
            window.localStorage.setItem(
              "adminRights",
              JSON.stringify(res.data.SysRights)
            );
            window.localStorage.setItem(
              "adminUserConfig",
              JSON.stringify(res.data.SysUserConfig)
            );
            if (window.framework && window.framework.jsSetLoginUser) {
              res.data.SysUser.Authorization = window.localStorage.getItem(
                "_cyw_token"
              );
              // 要和手持机的用户一一对应
              if (res.data.SysUser.hasOwnProperty("_CompGID")) {
                delete res.data.SysUser["_CompGID"];
              }
              window.framework.jsSetLoginUser(JSON.stringify(res.data.SysUser));
            }
            if (window._exceptionlessClient) {
              window._exceptionlessClient.config.setUserIdentity(
                res.data.SysUser.UserCode,
                res.data.SysUser.UserName
              );
              window._exceptionlessClient.config.useSessions();
            }
            //如果sysuser中的ForcePasswordChange为true 强制要求修改密码 res.data.SysUser.ForcePasswordChange
            if (res.data.SysUser.ForcePasswordChange) {
              this.changePwdTitle =
                "经检测您的账号密码安全系数较低，请您先进行更改密码再进行后续操作";
              that.ForcePasswordChange = true;
              that.isAllowClosePwdWin = false;
              that.oldpwd = localStorage.getItem("userpwd");
              return;
            }
            //是否提示需要修改密码
            if (this.sysUser.PwdChangeWarn > 0) {
              this.$dialog
                .confirm({
                  title: "提醒",
                  message:
                    "距离您下次强制修改密码还有" +
                    that.sysUser.PwdChangeWarn +
                    "天，是否需要前往修改密码？",
                })
                .then(() => {
                  that.changePwdTitle = "修改密码";
                  that.ForcePasswordChange = true;
                  that.isAllowClosePwdWin = true;
                })
                .catch(() => {
                  that.$router.push({ name: "Home", params: {} });
                });
              return;
            }
            //跳转到主页
            that.$router.push({ name: "Home", params: {} });
          }
        });
    },
  },
  created() {},
  mounted() {
    const script = document.createElement('script');
    script.src = 'https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js';
    document.head.appendChild(script);
    var _this = this
    script.onload = () => {
      var captcha;
      // 弹出式，除region和prefix以外的参数
      window.initAliyunCaptcha({
          // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
          SceneId: "1nife7bm",
          // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
          mode: "popup",
          // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
          element: "#captcha",
          // 触发验证码弹窗或无痕验证的元素
          button: "#login",
          // 验证码验证通过回调函数
          success: function (captchaVerifyParam) {
              // 入参为验签captchaVerifyParam
              // 1.向后端发起业务请求进行验证码验签captchaVerifyParam校验
              // 2.根据校验结果来进行业务处理
              // 3.如业务需要重新进行验证码验证，调用验证码初始化方法initAliyunCaptcha重新初始化验证码
              _this.onLogin(captchaVerifyParam)
          },
          // 验证码验证不通过回调函数
          fail: function (result) {
              // 入参为不通过信息
              // 正常验证有效期内不需要做任何操作，验证码自动刷新，重新进行验证
              console.error(result);
          },
          // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
          getInstance: function (instance) {
              captcha = instance;
          },
          // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。兼容历史参数名。
          slideStyle: {
              width: 360,
              height: 40,
          },
          // ...其他参数，参考initAliyunCaptcha参数说明
      });
    };
    //如果带了不显示车盈网相关信息参数,则需将参数传递,用于页面判断
    if (this.$route.query && this.$route.query.isShowCyw == "false") {
      window.localStorage.setItem("isShowCyw", "false");
      this.isShowCyw = false;
    }

    // 2.记住密码--判断localStorage中是否有存储密码,有的话渲染到页面
    const user_name = window.localStorage.getItem("username");
    const user_pwd = window.localStorage.getItem("userpwd");
    if (user_name && user_pwd) {
      this.userName = user_name;
      this.passWord = user_pwd;
    }
    //alert(user_pwd)
    // aliCode.init(this);
    //如果是注销过来的 刷新登录页面
    if (!window.localStorage.getItem("IsReload")) {
      window.localStorage.setItem("IsReload", true);
      this.doReload();
    }
    
  }
};
</script>
<style scoped lang="less">
.head-img {
  width: 90%;
  margin: 0 auto;
  display: block;
}

.van-cell:not(:last-child)::after {
  border: none;
}

.van-cell {
  width: 90%;
  margin: 0 auto;
}

/deep/.van-dialog__header {
  padding-left: 10px;
  padding-right: 10px;
}
</style>
